import React from "react";

export default function EventCard(props) {
  return (
    <div className="card cardStyle">
      <img class="card-img-top" src={props.image} alt={props.collegeName} />
      <div class="card-body">
        <h5 class="card-title">
          <h4>{props.collegeName}</h4>
        </h5>
        <br />
        <p class="card-text">
          <span style={{ fontSize: 20 }}>Topic: {props.topic}</span>
          <br />
          <br />
          <span style={{ fontSize: 18 }}>
            Conducted by:
            <a href={props.speakerLink}>{props.speaker}</a>
          </span>
          <br />
          <br />
          <span style={{ fontSize: 18 }}>{props.dateAndDay}</span>
        </p>
      </div>
    </div>
  );
}
